import React, { useEffect, useState } from "react";
// material
import { Box, Card, Container, Grid, Typography, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { getProfile } from "../core/service/users.service";
import VerifiedIcon from "@mui/icons-material/Verified";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

// components
import Page from "../components/Page";
import { ProfileView, MentorView } from "../components/profile";
import { ContractTimeChartPostDoc } from "../components/charts";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 150,
  marginTop: theme.spacing(5)
}));

export default function ProfilePostDoc() {
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [user, setUser] = useState({});

  const getUserProfile = async (id) => {
    const data = await getProfile(id);
    setUser(data);
  };

  useEffect(() => {
    getUserProfile(id);
  }, []);


  const checkRenewalApprove = user?.renewal_postdoc?.filter(
    (e) => e.admin_approve === 1
  );
  const checkResearchCardApprove = user?.research_card_postdoc?.filter(
    (e) => e.admin_approve === 1
  );
  const checkVisaApprove = user?.visa_extension_postdoc?.filter(
    (e) => e.admin_approve === 1
  );

  return (
    <Page title="Profile PostDoc">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4"> Profile PostDoc</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <ProfileView user={user} />
          </Grid>

          <Grid item xs={12} md={8} lg={4}>
            <MentorView detail={user?.my_mentor || {}} />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <ContractTimeChartPostDoc
              postdoctoral_information={user?.postdoctoral_information}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            {/* <PaperAccepted /> */}
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <ChartWrapperStyle dir="ltr">
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ paddingTop: 5 }}
                >
                  <Stack direction="row" spacing={2}>
                    <Typography variant="h6" component="div">
                      Renewal Status:
                    </Typography>
                    {user?.renewal_postdoc?.length === 0 ? (
                      <Typography color="text.secondary">-</Typography>
                    ) : checkRenewalApprove?.length === 0 ? (
                      <Stack direction="row" spacing={1}>
                        <Typography color="text.secondary">Pending</Typography>
                        <PendingActionsIcon />
                      </Stack>
                    ) : (
                      <Stack direction="row" spacing={1}>
                        <Typography color="text.secondary">Complete</Typography>
                        <VerifiedIcon sx={{ color: "#1CD1A1" }} />
                      </Stack>
                    )}
                  </Stack>
                </Grid>
              </ChartWrapperStyle>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <ChartWrapperStyle dir="ltr">
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ paddingTop: 5 }}
                >
                  <Stack direction="row" spacing={2}>
                    <Typography variant="h6" component="div">
                      Researcher Card status:
                    </Typography>
                    {user?.research_card_postdoc?.length === 0 ? (
                      <Typography color="text.secondary">-</Typography>
                    ) : checkResearchCardApprove?.length === 0 ? (
                      <Stack direction="row" spacing={1}>
                        <Typography color="text.secondary">Pending</Typography>
                        <PendingActionsIcon />
                      </Stack>
                    ) : (
                      <Stack direction="row" spacing={1}>
                        <Typography color="text.secondary">Complete</Typography>
                        <VerifiedIcon sx={{ color: "#1CD1A1" }} />
                      </Stack>
                    )}
                  </Stack>
                </Grid>
              </ChartWrapperStyle>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <ChartWrapperStyle dir="ltr">
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ paddingTop: 5 }}
                >
                  <Stack direction="row" spacing={2}>
                    <Typography variant="h6" component="div">
                      Visa Extension status:
                    </Typography>
                    {user?.visa_extension_postdoc?.length === 0 ? (
                      <Typography color="text.secondary">-</Typography>
                    ) : checkVisaApprove?.length === 0 ? (
                      <Stack direction="row" spacing={1}>
                        <Typography color="text.secondary">Pending</Typography>
                        <PendingActionsIcon />
                      </Stack>
                    ) : (
                      <Stack direction="row" spacing={1}>
                        <Typography color="text.secondary">Complete</Typography>
                        <VerifiedIcon sx={{ color: "#1CD1A1" }} />
                      </Stack>
                    )}
                  </Stack>
                </Grid>
              </ChartWrapperStyle>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
